import React, { useEffect, useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import "./Login_Modal.css";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  sendMobileOtpSingUp,
  userSignUp,
  verifyOtp,
} from "../../../../../features/auth/authSlice";
import { myAccount } from "../../../../../features/my_account/Slice";
import { CountryCode } from "../../../../../features/master/masterSlice";
import OtpInput from "react-otp-input";
import Black_Btn from "../../../common_btn/Black_Btn/Black_Btn";
import { ClipLoader } from "react-spinners";

const SingUp_Modal = ({ onHide, setShowSignUp }) => {
  const {
    control,
    register,
    handleSubmit,
    setError,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange", //validate while typing
    reValidateMode: "onChange", // revalidate instantly
  });

  const options = [
    { value: "+91", label: "+91" },

    { value: "+91", label: "+91" },

    { value: "+91", label: "+91" },
  ];

  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [loder, setLoder] = useState("");

  const [loderSend, setLoderSend] = useState("");

  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const dispatch = useDispatch();
  const isSignin = useSelector((state) => state.auth.is_signin);

  const [verifyStatus, setVerifyStatus] = useState(false);

  const onSubmit = async (data) => {
    if (!data.contact_no || errors?.contact_no) {
      return; //don't proceed if invalid mobile
    }

    // if (!verifyStatus) {
    //   if (showmobOtp) {
    //     setOtpError("Please Verify Mobile Number");
    //   } else {
    //     setMobileNoError("Please Verify Mobile Number");
    //   }
    //   return;
    // }

    if (!verifyStatus) {
      // Invalid mobile number
      if (!data.contact_no || data.contact_no.length !== 10) {
        setMobileNoError("Please Enter Valid Mobile No");
        return;
      }

      // OTP not sent yet
      if (!showmobOtp) {
        setMobileNoError("Please Send OTP");
        return;
      }

      // OTP box visible but not verified
      if (showmobOtp && otp.length !== 4) {
        setOtpError("Please Enter Valid OTP");
        return;
      }

      // OTP entered but not verified
      setOtpError("Please Verify OTP");
      return;
    }

    setLoder(true);

    const res = await dispatch(userSignUp(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setLoder(false);

      reset();
      setOtp("");
      setVerifyStatus(false);
      setShowmobOtp(false);
      setTimer(0);
      setMobileNoError("");
      setOtpError("");

      await dispatch(myAccount());

      setSuccessMsg("Sign Up Succesfully !");
      setShowSucsessModal(true);

      onHide();

      setTimeout(() => {
        navigate("/");
        setShowSucsessModal(false);
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
      setLoder(false);
      if (res.payload?.errors?.email) {
        setError("email", {
          type: "manual",
          message: res.payload?.errors?.email,
        });
      }
      if (res.payload?.errors?.contact_no) {
        setError("contact_no", {
          type: "manual",
          message: res.payload?.errors?.contact_no,
        });
      }
    }
  };

  const user = useSelector((state) => state.myaccount.addMyaccount);

  // useEffect(() => {
  //   if (user?.id) {
  //     dispatch(myAccount());
  //   }
  // }, []);

  const countryCode = useSelector((state) => state.master.country_code);

  useEffect(() => {
    dispatch(CountryCode());
  }, []);

  const [otp, setOtp] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [showmobOtp, setShowmobOtp] = useState(false);
  const [otpError, setOtpError] = useState("");
  const mobileNo = watch("contact_no");
  const [timer, setTimer] = useState(0);

  const sendOtp = async (e) => {
    e.preventDefault();

    //CLEAR ALL STATES BEFORE SENDING
    setMobileNoError("");
    setOtpError("");
    setVerifyStatus(false);
    setOtp("");

    // if (!selectedCode) {
    //   setMobileNoError("Select country code first");
    //   return;
    // }

    if (!mobileNo || mobileNo.trim() === "") {
      setMobileNoError("");
      return;
    }

    if (mobileNo.length < 10) {
      setOtp("");
      setOtpError("");
      setShowmobOtp(false);
      setTimer(0);
      setMobileNoError("Please Enter Valid Mobile No");
      return;
    }
    setMobileNoError("");

    //RESET OTP HERE
    setOtp(""); // clear entered digits
    setOtpError(""); // clear error also

    setLoderSend(true);
    try {
      const data = { contact_no: mobileNo };
      const res = await dispatch(sendMobileOtpSingUp(data));

      if (res.meta?.requestStatus === "fulfilled") {
        setLoderSend(false);
        // handleNext();
        setShowmobOtp(true);
        setTimer(60);
      } else if (res.meta?.requestStatus === "rejected") {
        setLoderSend(false);
        setMobileNoError(res.payload?.errors);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  const handleGetmobOtp = (e) => {
    e.preventDefault();
    // setMobileNoError("");
    sendOtp();
  };

  const [selectedCode, setSelectedCode] = useState(null);
  const handleVerifyOtp = async () => {
    if (!otp) {
      setOtpError("Provide Four Digit OTP");
      return;
    }
    try {
      const data = { contact_no: mobileNo, otp };
      const res = await dispatch(verifyOtp(data)); // <-- redux thunk action

      if (res.meta?.requestStatus === "fulfilled") {
        setVerifyStatus(true);
        setShowmobOtp(false);
        setMobileNoError("");
        setOtpError("");
      } else if (res.meta?.requestStatus === "rejected") {
        setOtpError(
          res.payload?.errors || "An error occurred. Please try again.",
        );
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setOtpError("An unexpected error occurred. Please try again.");
    }
  };

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(interval);

      // Clear OTP states when timer ends
      setOtp("");
      setOtpError("");
    }
    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    if (mobileNo) {
      setMobileNoError("");
      setOtpError("");
      setVerifyStatus(false);
      setShowmobOtp(false);
      setOtp("");
      setTimer(0); //reset expiry timer
    }
  }, [mobileNo]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  return (
    <>
      <div className="signup_div">
        <div className="login_form_div">
          <Form autoComplete="off">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter First name"
                    {...register("name", {
                      required: "Name is required",
                    })}
                  />
                  {errors?.name && (
                    <div style={{ fontSize: "13px", color: "red" }}>
                      {errors?.name?.message}
                    </div>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Last name"
                    {...register("last_name", {
                      required: "Last Name is required",
                    })}
                  />
                  {errors.last_name && (
                    <div style={{ fontSize: "13px", color: "red" }}>
                      {errors?.last_name?.message}
                    </div>
                  )}
                </Form.Group>
              </div>
            </div>

            <Form.Group className="gray_input_group input_group">
              <Form.Label>Email ID</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                placeholder="Enter your email "
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                    message: "Email Address Invalid",
                  },
                })}
              />
              {errors?.email && (
                <sup className="text-danger">{errors?.email?.message}</sup>
              )}
            </Form.Group>

            <Form.Group className="gray_input_group input_group">
              <Form.Label className="label_text">Password</Form.Label>
              <div className="password_holder">
                <Form.Control
                  autoComplete="new-password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter Password"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                    pattern: {
                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                      message:
                        "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                    },
                    onChange: (e) => setPassword(e.target.value), // correct way
                  })}
                />
                {errors?.password && (
                  <sup className="text-danger">{errors?.password?.message}</sup>
                )}
                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconOne}
                    className="icon"
                    onClick={() => togglePasswordVisibility("password")}
                  />
                </div>
              </div>
            </Form.Group>

            <Form.Group className="gray_input_group input_group">
              <Form.Label className="label_text">Confirm Password</Form.Label>
              <div className="password_holder">
                <Form.Control
                  placeholder="Confirm Password"
                  type={showPasswordOne ? "text" : "password"}
                  name="re_password"
                  {...register("re_password", {
                    required: "Re-Enter Password  is required",
                    onChange: (e) => setPasswordAgain(e.target.value),
                  })}
                />

                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconTwo}
                    className="icon"
                    onClick={() => togglePasswordVisibility("reenterPassword")}
                  />
                </div>
                {errors?.re_password && (
                  <sup className="text-danger">
                    {errors?.re_password?.message}
                  </sup>
                )}
              </div>
            </Form.Group>

            {password && (
              <div className="password_check_list">
                <PasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "match",
                  ]}
                  minLength={8}
                  value={password}
                  valueAgain={passwordAgain}
                  onChange={(isValid) => {}}
                  style={{
                    fontSize: "10px",
                    padding: "4px",
                    margin: "0",
                  }}
                />
              </div>
            )}

            <div className="row mt-2">
              <div className="col-sm-12">
                <Form.Group className="gray_input_group input_group Contact_field_holder">
                  <Form.Label>Contact</Form.Label>

                  <InputGroup className="mb-3">
                    {/* <InputGroup.Text id="basic-addon1">
                      <Controller
                        name="country_code_id" // name of the field
                        {...register("country_code_id", {
                          // required: "Select Country Code",
                        })}
                        control={control}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.country_code_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={countryCode}
                            onChange={(val) => {
                              field.onChange(val);
                              setSelectedCode(val); // 👈 store selection
                            }}
                          />
                        )}
                      />
                    </InputGroup.Text> */}

                    <Form.Control
                      placeholder="Enter Contact Number"
                      aria-label="Contact"
                      aria-describedby="basic-addon1"
                      type="text"
                      // readOnly={verifyStatus}
                      readOnly={showmobOtp || verifyStatus}
                      maxLength={selectedCode?.length || 10} // 👈 fallback 10
                      {...register("contact_no", {
                        required: "Contact number is required",
                        pattern: {
                          value: /^[6-9]\d{9}$/,
                          message: "Enter valid 10-digit contact number",
                        },
                      })}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </InputGroup>
                  {errors?.country_code_id && (
                    <sup className="text-danger">
                      {errors?.country_code_id?.message}
                    </sup>
                  )}

                  {errors?.contact_no && (
                    <sup className="text-danger">
                      {errors?.contact_no?.message}
                    </sup>
                  )}
                  {!errors?.contact_no && mobileNoError && (
                    <span className="text-danger">{mobileNoError}</span>
                  )}

                  <div className="otpbtnholder">
                    {verifyStatus ? (
                      <p className="verify">Verify</p>
                    ) : (
                      <>
                        {!showmobOtp && (
                          <>
                            {loderSend ? (
                              <div className="text-center">
                                <ClipLoader />
                              </div>
                            ) : (
                              <button className="sendotp" onClick={sendOtp}>
                                Send OTP
                              </button>
                            )}
                          </>
                        )}

                        {timer === 0 && showmobOtp && (
                          <button className="sendotp" onClick={sendOtp}>
                            Resend OTP
                          </button>
                        )}
                      </>
                    )}
                  </div>

                  {showmobOtp && timer > 0 && (
                    <div className="otp_inputes">
                      <OtpInput
                        value={otp}
                        onChange={(value) => {
                          const numericValue = value.replace(/\D/g, ""); // remove non-digits
                          setOtp(numericValue);
                          setOtpError(""); // clear error while typing
                        }}
                        numInputs={4}
                        renderSeparator={<span>-</span>}
                        renderInput={(props) => (
                          <input
                            {...props}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                        )}
                      />
                      {/* <OtpInput
                        value={otp}
                        onChange={setOtp}
                        isInputNum={true}
                        numInputs={4}
                        renderSeparator={<span>-</span>}
                        renderInput={(props) => <input {...props} />}
                      /> */}

                      <button
                        className="verifyotpbtn"
                        onClick={(e) => {
                          e.preventDefault();
                          handleVerifyOtp();
                        }}
                      >
                        Verify
                      </button>
                      {timer > 0 && (
                        <div className="timer_holder">
                          <p>{timer} Seconds</p>
                        </div>
                      )}
                    </div>
                  )}
                  {otpError && <span className="text-danger">{otpError}</span>}
                </Form.Group>
              </div>

              {/* <div className="col-sm-12">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    max={new Date().toISOString().split("T")[0]} // disable future dates
                    {...register("date", {
                      required: "Date of birth is required",
                      validate: {
                        notFuture: (value) =>
                          new Date(value) <= new Date() ||
                          "Future date not allowed",
                      },
                    })}
                  />
                  {errors?.date && (
                    <div style={{ fontSize: "13px", color: "red" }}>
                      {errors?.date?.message}
                    </div>
                  )}
                </Form.Group>
              </div> */}
            </div>
          </Form>
        </div>
        {loder ? (
          <>
            <div className="text-center">
              <ClipLoader />
            </div>
          </>
        ) : (
          <div className="btn_holder">
            <Black_Btn
              btnText="Sign Up"
              onClick={handleSubmit(onSubmit, () => {
                // STOP if contact number field itself has validation error
                if (
                  errors?.contact_no ||
                  !watch("contact_no") ||
                  watch("contact_no").trim() === ""
                ) {
                  setMobileNoError("");
                  setOtpError("");
                  return;
                }

                // ONLY check OTP validations if contact number is valid
                if (!verifyStatus) {
                  if (!showmobOtp) {
                    setMobileNoError("Please Send OTP");
                    return;
                  }

                  if (otp.length !== 4) {
                    setOtpError("Please Enter Valid OTP");
                    return;
                  }

                  if (!otpError) {
                    setOtpError("Please Verify OTP");
                  }
                }
              })}
            />
          </div>
        )}

        <p className="dark_text">
          Already have an account?{" "}
          <span
            className="link_text"
            onClick={() => {
              setShowSignUp(false);
            }}
          >
            Log In
          </span>
          .
        </p>
      </div>
    </>
  );
};

export default SingUp_Modal;
